export default __webpack_public_path__ + "static/mazuis-review-italic-7ef9b83c4b8f8b362679d7801dc00cd6.otf";